var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpecialSvg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1918,
    height: 218,
    viewBox: "0 0 1918 218",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M246 202C122.8 212.8 30.6667 174.5 0 154V217.5H1918V0C1828.8 112.8 1532 158 1325.5 116.5C1119 75 986.5 74.3936 865 106C569 183 400 188.5 246 202Z",
    fill: "#F7F7F7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpecialSvg);
export default __webpack_public_path__ + "static/media/specialSvg.0f4d464b3c575523bddfe8d9b86a126e.svg";
export { ForwardRef as ReactComponent };